import {
  ARROWS_DISTANCE,
  ARROWS_ROTATION,
  CIRCLE_SIZE,
  ENABLE_APARTMENT_TOUR,
  LINE_COLOR,
  LINE_START,
  LINE_WIDTH,
  MAX_DISTANCE,
  MAX_POLAR_ANGLE,
  MIN_POLAR_ANGLE,
  PODIUM_SCALE,
  RESIZE_MODEL,
  ROTATE_FLOORS,
  ROTATE_MODEL,
  SHOW_INITIAL_ANIMATION,
  SHOW_OCEAN,
  TRANSPARENCY,
  X,
  Z,
} from "../../constants";
import { maxPolarAngle, minPolarAngle } from "../CameraController";
export const initialLineWidth = 30;

export const defaultSettings = {
  Project: [
    {
      label: ARROWS_DISTANCE,
      type: "number",
      value: 3,
      property: "arrowsRadiusOffset",
    },
    {
      label: ARROWS_ROTATION,
      type: "number",
      value: 0,
      property: "arrowsRotation",
      step: 0.1
    },
    // {
    //   label: CIRCLE_SIZE,
    //   type: "number",
    //   value: 1,
    //   step: 0.1,
    //   property: "mainCircleRadiusOffset",
    // },
    {
      label: PODIUM_SCALE,
      type: "number",
      value: 1,
      step: 0.1,
      property: "podiumScale",
    },
    {
      label: MAX_DISTANCE,
      type: "number",
      value: 350,
      property: "maxDistance",
    },
    {
      label: TRANSPARENCY,
      type: "number",
      value: 0.3,
      step: 0.1,
      property: "transparency",
    },
    {
      label: SHOW_INITIAL_ANIMATION,
      type: "checkbox",
      value: true,
      property: "showInitialAnimation",
    },
    {
      label: SHOW_OCEAN,
      type: "checkbox",
      value: true,
      property: "showOcean",
    },
    {
      label: ENABLE_APARTMENT_TOUR,
      type: "checkbox",
      value: false,
      property: "enableApartmentTour",
    },
  ],
  // console.log({ selectedBuilding })
  Buildings: [
    {
      label: X,
      type: "number",
      value: 0,
      property: "x",
      step: 0.1,
    },
    {
      label: Z,
      type: "number",
      value: 0,
      property: "z",
      step: 0.1,
    },
    {
      label: RESIZE_MODEL,
      type: "number",
      value: 1,
      property: "scale",
      step: 0.1,
    },
    {
      label: ROTATE_MODEL,
      type: "number",
      value: 0,
      property: "rotationY",
      step: 0.1,
    },
    {
      label: ROTATE_FLOORS,
      type: "number",
      value: 0,
      property: "floorsRotationY",
      step: 0.1,
    },
    {
      label: CIRCLE_SIZE,
      type: "number",
      value: 3,
      property: "buildingRadiusOffset",
    },
  ],
  View360: [
    {
      label: MIN_POLAR_ANGLE,
      type: "number",
      value: minPolarAngle,
      property: "minPolarAngle",
      step: 1,
    },
    {
      label: MAX_POLAR_ANGLE,
      type: "number",
      value: maxPolarAngle,
      property: "maxPolarAngle",
      step: 1,
    },

  ],
  // Points: [
  //   {
  //     label: "Point name",
  //     type: "text",
  //     value: "",
  //     property: "name",

  //   },

  // ],
//   Tiles: [
//     {
//       label: X,
//       type: "number",
//       value: 0,
//       property: "x",
//       step: 0.1,
//     },
//     {
//       label: Z,
//       type: "number",
//       value: 0,
//       property: "z",
//       step: 0.1,
//     },
//     {
//       label: RESIZE_MODEL,
//       type: "number",
//       value: 1,
//       property: "scale",
//       step: 0.1,
//     },
//     {
//       label: ROTATE_MODEL + "X",
//       type: "number",
//       value: 0,
//       property: "rotationX",
//       step: 0.1,
//     },
//     {
//       label: ROTATE_MODEL + "Y",
//       type: "number",
//       value: 0,
//       property: "rotationY",
//       step: 0.1,
//     },
//     {
//       label: ROTATE_MODEL + "Z",
//       type: "number",
//       value: 0,
//       property: "rotationZ",
//       step: 0.1,
//     },
//   ],
  Floors: [
    {
      label: LINE_COLOR,
      type: "color",
      value: "#ff0000",
      property: "floorLineColor",
      step: 0.1,
    },
    {
      label: LINE_START,
      type: "number",
      value: 0,
      property: "lineStart",
      step: 1,
    },
    {
      label: LINE_WIDTH,
      type: "number",
      value: initialLineWidth,
      property: "lineWidth",
      step: 1,
    },

    // {
    //   label: "Label size",
    //   type: "number",
    //   value: 3,
    //   property: "floorsLabelsSize",
    // },
  ],
};
